import Order from './pages/Order/store'
import List from './pages/List/store'

export default {
  namespaced: true,
  modules: {
    order: Order,
    list: List
  },
  state () {
    return {}
  },
  getters: {},
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/app/store.js